<template>
  <div id="footer">
    <br>
    <small>
      All the content related to Scrum Guide comes from scrumguides.org and is under the Attribution
      ShareAlike license of Creative Commons. Further information is accessible at
      http://creativecommons.org/licenses/by-sa/4.0/legalcode and also described in summary form
      at http://creativecommons.org/licenses/by-sa/4.0/.
    </small>
    <br>
    <br>
    <p>
        ScrumQuiz.org |
        <router-link to="/imprint">
          <a href="#" class="btn btn-link">Imprint</a>
        </router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>
